/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ZohoServiceDeskPolicyDescriptionAttribute {
    policy_id = 'policy_id',
    display_name = 'display_name',
    status = 'status',
    services = 'services',
    policy_type = 'policy_type',
    engine_type = 'engine_type',
    resources = 'resources',
    resource_id = 'resource_id',
    resource_name = 'resource_name',
    region = 'region',
    service_accounts = 'service_accounts',
    content_type = 'content_type',
    classification = 'classification',
    sub_classification = 'sub_classification',
    severity = 'severity'
}
